module.exports = __webpack_public_path__ + "img/arrow-bottom-gray-12px.5526ad4f.svg";